import Link from "next/link";
import { type JSX } from "react";
import LazyLoad from 'react-lazyload';
import { UCMARKETINGPAGES } from "../../../utils/useCasesMarketingPages";
import { H4 } from "../../Typography";
import { VerticalSpacing } from "../../VerticalSpacing";
import { NavigationUseCaseWrapper, UseCaseSlideBody, UseCaseSlideBodyQuotationMark, UseCaseSlideBodyQuote, UseCaseSlideTestimonialWrapper, UseCaseSlideWrapperTwo } from "./UseCaseSlides.styles";

type SlideUseCaseTemplateProps = {
    targetGroup: string,
    link: string,
    desktopImg: string,
    firstQuote: string,
    secondQuote: string,
    thirdQuote: string,
    customerName: string,
    customerOccupation: string,
    customerStats: string,
    icon: JSX.Element
}

const SlideUseCaseTemplate = ({ desktopImg, link, targetGroup, firstQuote, secondQuote, thirdQuote, customerName, customerOccupation, customerStats, icon }: SlideUseCaseTemplateProps) => <UseCaseSlideWrapperTwo>
    <div>
        <UseCaseSlideTestimonialWrapper>
            <UseCaseSlideBodyQuotationMark><strong>“</strong></UseCaseSlideBodyQuotationMark>
            <UseCaseSlideBodyQuote><strong>{firstQuote}</strong></UseCaseSlideBodyQuote>
            <VerticalSpacing top={10}>
                <UseCaseSlideBodyQuote>{secondQuote}</UseCaseSlideBodyQuote>
            </VerticalSpacing>
            <VerticalSpacing top={10}>
                <UseCaseSlideBodyQuote>{thirdQuote}</UseCaseSlideBodyQuote>
            </VerticalSpacing>
            <VerticalSpacing top={30}>
                <UseCaseSlideBody><strong>{customerName}</strong> {customerOccupation}</UseCaseSlideBody>
            </VerticalSpacing>
            <UseCaseSlideBody>{customerStats}</UseCaseSlideBody>
        </UseCaseSlideTestimonialWrapper>
    </div>
    <div>
        <div>
            <LazyLoad offset={500}>
                <Link href={link}>
                    <img src={desktopImg} />
                </Link>
            </LazyLoad>
        </div>
        <div>
            <Link href={link}>
                <NavigationUseCaseWrapper>
                    <div>
                        {icon}
                    </div>
                    <div>
                        <H4>How Authory helps <strong>{targetGroup}</strong></H4>
                    </div>
                    <div>
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.70122 6.32613C7.09959 6.6983 7.09959 7.3017 6.70122 7.67387L1 13" stroke="#2E77FF" />
                        </svg>
                    </div>
                </NavigationUseCaseWrapper>
            </Link>
        </div>
    </div>
</UseCaseSlideWrapperTwo>

const SlideUseCaseWritersTwo = () => <SlideUseCaseTemplate
    desktopImg={"/authory_static_files/images/homepage/sliders/use-cases/writers_desktop.png"}
    firstQuote="“Authory is effortless."
    secondQuote="For less than the cost than running my own website I have a clean, up-to-date, searchable portfolio that I don't have to manage."
    thirdQuote="Authory is like having my own mini marketing team that lets me focus on the work I love doing.”"
    customerName="Colleen Fisher Tully,"
    customerOccupation="Writer"
    customerStats="165 articles at 26 publications"
    targetGroup={"Writers"}
    link={UCMARKETINGPAGES[0].route}
    icon={<img src="/authory_static_files/images/icons/writers_xs_active.svg" />}
/>;

const SlideUseCaseJournalistsTwo = () => <SlideUseCaseTemplate
    desktopImg={"/authory_static_files/images/homepage/sliders/use-cases/journalists_desktop.png"}
    firstQuote="“I use Authory not only as a portfolio to showcase my work, but also as a file cabinet."
    secondQuote="I have 10+ years of automotive features posted and often use my older work for reference."
    thirdQuote="With Authory, I can look up my published stories faster than I can find them on my computer.”"
    customerName="Jim Koscs,"
    customerOccupation="Journalist"
    customerStats="256 articles at 13 publications"
    targetGroup={"Journalists"}
    link={UCMARKETINGPAGES[1].route}
    icon={<img src="/authory_static_files/images/icons/journalists_xs_active.svg" />}
/>;

const SlideUseCaseContentMarketersTwo = () => <SlideUseCaseTemplate
    desktopImg={"/authory_static_files/images/homepage/sliders/use-cases/content_marketers_desktop.png"}
    firstQuote="“Authory really is a content marketer's dream!"
    secondQuote="One aspect I dread about having a website is manually updating it."
    thirdQuote="Now, Authory does that for me, saving me time and headspace while allowing me to maintain my brand.”"
    customerName="Alyssa Towns Swantkoski,"
    customerOccupation="Content Marketer"
    customerStats="134 articles at 8 publications"
    targetGroup={"Content Marketers"}
    link={UCMARKETINGPAGES[2].route}
    icon={<img src="/authory_static_files/images/icons/content_marketers_xs_active.svg" />}
/>;

const SlideUseCaseThoughtLeaderTwo = () => <SlideUseCaseTemplate
    desktopImg={"/authory_static_files/images/homepage/sliders/use-cases/thought_leaders_desktop.png"}
    firstQuote="“Authory is a dream for me."
    secondQuote="It collects and curates my media articles, blogposts and podcasts. "
    thirdQuote="And I love the aesthetic of the platform which is really innovative and professional.”"
    customerName="Lili-Ann Kriegler,"
    customerOccupation="Thought Leader"
    customerStats="87 articles at 17 sources"
    targetGroup={"Thought Leaders"}
    link={UCMARKETINGPAGES[3].route}
    icon={<img src="/authory_static_files/images/icons/thought_leaders_xs_active.svg" />}
/>;

export const UseCasesSlides2 = [
    <SlideUseCaseWritersTwo />,
    <SlideUseCaseJournalistsTwo />,
    <SlideUseCaseContentMarketersTwo />,
    <SlideUseCaseThoughtLeaderTwo />,
]